"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewslettterSignupFormFields = void 0;
const react_1 = __importStar(require("react"));
const client_1 = require("@apollo/client");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_duotone_svg_icons_1 = require("@fortawesome/pro-duotone-svg-icons");
const emailmarketing_1 = require("./graphql/emailmarketing");
const Button_1 = __importDefault(require("../Button"));
const Form_1 = __importDefault(require("../Form"));
const FormField_1 = __importDefault(require("../FormField"));
const FormProvider_1 = __importDefault(require("../FormProvider"));
const Grid_1 = __importDefault(require("../Grid"));
const Heading_1 = __importDefault(require("../Heading"));
const Input_1 = __importDefault(require("../Input"));
const Link_1 = __importDefault(require("../Link"));
const Section_1 = __importDefault(require("../Section"));
const validation_1 = require("../../shared/validation");
const constants_1 = require("../../utils/constants");
const analyticsUtils_1 = require("../../utils/analyticsUtils");
const FormFieldError_1 = __importDefault(require("../FormFieldError"));
const styles = require('./NewsletterSignupSection.module.scss');
var NewslettterSignupFormFields;
(function (NewslettterSignupFormFields) {
    NewslettterSignupFormFields["Email"] = "email";
    NewslettterSignupFormFields["Source"] = "source";
    NewslettterSignupFormFields["SubscriptionTypes"] = "subscriptionTypes";
})(NewslettterSignupFormFields = exports.NewslettterSignupFormFields || (exports.NewslettterSignupFormFields = {}));
const NewsletterSignupSection = () => {
    const fieldsOptions = (0, react_1.useMemo)(() => ({
        [NewslettterSignupFormFields.Email]: {
            isRequired: true,
            validationRules: [validation_1.validateEmail, (0, validation_1.validateMaxLength)(150)],
        },
    }), []);
    const [submitFormMutation, { error, data, loading: isLoading }] = (0, client_1.useMutation)(emailmarketing_1.EMAIL_MARKETING_SIGNUP);
    const submitFormHandler = (0, react_1.useMemo)(() => (values) => {
        submitFormMutation({ variables: values });
        (0, analyticsUtils_1.sendGtmEvent)(constants_1.GtmEvents.ReactDataLayerPush, (0, analyticsUtils_1.getGtmEventTrackingDataAttributes)({
            category: analyticsUtils_1.AnalyticsCategoryType.Footer,
            action: 'newsletter signup',
        }));
    }, [submitFormMutation]);
    const isSent = data === null || data === void 0 ? void 0 : data.signup.isSent;
    return (react_1.default.createElement(Section_1.default, null,
        react_1.default.createElement(Grid_1.default, { container: true },
            react_1.default.createElement(Grid_1.default, { item: true, lg: 3 }),
            react_1.default.createElement(Grid_1.default, { item: true, lg: 6 },
                react_1.default.createElement(FormProvider_1.default, { name: constants_1.Form.Newsletter, onSubmit: submitFormHandler, fieldsOptions: fieldsOptions, initialValues: {
                        [NewslettterSignupFormFields.Email]: '',
                        [NewslettterSignupFormFields.Source]: 'signup_widget',
                        [NewslettterSignupFormFields.SubscriptionTypes]: ['news', 'promotions'],
                    } }, ({ values }) => {
                    const { email } = values;
                    return (react_1.default.createElement(react_1.default.Fragment, null, !isSent ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: styles.heading },
                            react_1.default.createElement(Heading_1.default, { level: "2", displayAs: "2" }, "Sign up to our emails")),
                        react_1.default.createElement(Heading_1.default, { level: "3", displayAs: "6", className: styles.text }, "Get the hottest news, events, and promotions sent straight to your inbox"),
                        react_1.default.createElement(Form_1.default, null,
                            react_1.default.createElement("div", { className: styles.layout },
                                react_1.default.createElement(FormField_1.default, { name: NewslettterSignupFormFields.Email }, ({ onChange, onBlur, errors }) => (react_1.default.createElement(Input_1.default, { classes: { label: styles.label }, hasError: !!errors.length, id: NewslettterSignupFormFields.Email, isLabelHidden: true, label: "Email address", onBlur: onBlur, onChange: (e) => onChange(e.target.value), placeholder: "e.g. henry@ford.com", type: "email", value: email }))),
                                react_1.default.createElement(Button_1.default, { type: "submit", color: "green", isLoading: isLoading }, "Submit"),
                                error && (react_1.default.createElement(FormFieldError_1.default, null, "An error has occured. Please try again."))),
                            react_1.default.createElement("p", { className: styles.terms },
                                "By signing up you agree to our",
                                ' ',
                                react_1.default.createElement(Link_1.default, { color: "grey", href: "/privacy-policy" }, "Privacy Policy"),
                                ' ',
                                "and",
                                ' ',
                                react_1.default.createElement(Link_1.default, { color: "grey", href: "/terms-and-conditions" }, "Terms and Conditions"),
                                ". Sometimes our emails will contain ads from our trusted partners. You can unsubscribe at any time.")))) : (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: styles.heading },
                            react_1.default.createElement(Heading_1.default, { level: "2" }, "Thanks for signing up")),
                        react_1.default.createElement("div", { className: styles.center },
                            react_1.default.createElement("div", { className: styles.iconContainer },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_duotone_svg_icons_1.faCheckCircle, className: styles.icon, size: "4x" })),
                            react_1.default.createElement(Heading_1.default, { level: "3", displayAs: "6", className: styles.text }, "Keep an eye on your inbox for the best of PH soon!"))))));
                })))));
};
exports.default = NewsletterSignupSection;
//# sourceMappingURL=NewsletterSignupSection.js.map